export const S3_IMAGE_BASE_URL =
  process.env.NEXT_PUBLIC_S3_IMAGE_BASE_URL || ""

/**
 * Resolve a stored image key to a full, renderable URL.
 *
 * - Full URLs (http://, https://) and root-relative paths (/...) are returned as-is,
 *   so external image URLs (e.g. from the Kale catalogue) work out of the box.
 * - Everything else is treated as an S3 key and prefixed with the S3 base URL,
 *   matching how the rest of the storefront images are served.
 */
export function resolveImageUrl(imageKey?: string | null): string | null {
  if (!imageKey) return null
  if (
    imageKey.startsWith("http://") ||
    imageKey.startsWith("https://") ||
    imageKey.startsWith("/")
  ) {
    return imageKey
  }

  const base = S3_IMAGE_BASE_URL.replace(/\/$/, "")
  return `${base}/${imageKey.replace(/^\//, "")}`
}
